import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type MergeProductionCategoryMutationVariables = Types.Exact<{
  input: Types.MergeProductionCategoryInput;
}>;


export type MergeProductionCategoryMutation = { __typename?: 'Mutation', mergeProductionCategory: { __typename?: 'ProductionCategoryPayload', productionCategory?: { __typename?: 'ProductionCategoryStateData', productionCategoryId: string, tenantId: string, code: string, label?: string | null, eaches: number, laborCostPerUnit?: number | null, laborCostEffectiveDate?: Types.TDateISO | null, unitsPerPole?: number | null, status: Types.ProductionCategoryStatus, productionTaskEventIds: Array<string>, productionSpaceEventIds: Array<string>, productionSpaceCategoryId: string, productionMaterialEventIds: Array<string>, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ActivateProductionCategoryMutationVariables = Types.Exact<{
  input: Types.ActivateProductionCategoryInput;
}>;


export type ActivateProductionCategoryMutation = { __typename?: 'Mutation', activateProductionCategory: { __typename?: 'ProductionCategoryPayload', productionCategory?: { __typename?: 'ProductionCategoryStateData', productionCategoryId: string, tenantId: string, code: string, label?: string | null, eaches: number, laborCostPerUnit?: number | null, laborCostEffectiveDate?: Types.TDateISO | null, unitsPerPole?: number | null, status: Types.ProductionCategoryStatus, productionTaskEventIds: Array<string>, productionSpaceEventIds: Array<string>, productionSpaceCategoryId: string, productionMaterialEventIds: Array<string>, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeactivateProductionCategoryMutationVariables = Types.Exact<{
  input: Types.DeactivateProductionCategoryInput;
}>;


export type DeactivateProductionCategoryMutation = { __typename?: 'Mutation', deactivateProductionCategory: { __typename?: 'ProductionCategoryPayload', productionCategory?: { __typename?: 'ProductionCategoryStateData', productionCategoryId: string, tenantId: string, code: string, label?: string | null, eaches: number, laborCostPerUnit?: number | null, laborCostEffectiveDate?: Types.TDateISO | null, unitsPerPole?: number | null, status: Types.ProductionCategoryStatus, productionTaskEventIds: Array<string>, productionSpaceEventIds: Array<string>, productionSpaceCategoryId: string, productionMaterialEventIds: Array<string>, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateProductionCategoryDetailsMutationVariables = Types.Exact<{
  input: Types.UpdateProductionCategoryDetailsInput;
}>;


export type UpdateProductionCategoryDetailsMutation = { __typename?: 'Mutation', updateProductionCategoryDetails: { __typename?: 'ProductionCategoryPayload', productionCategory?: { __typename?: 'ProductionCategoryStateData', productionCategoryId: string, tenantId: string, code: string, label?: string | null, eaches: number, laborCostPerUnit?: number | null, laborCostEffectiveDate?: Types.TDateISO | null, unitsPerPole?: number | null, status: Types.ProductionCategoryStatus, productionTaskEventIds: Array<string>, productionSpaceEventIds: Array<string>, productionSpaceCategoryId: string, productionMaterialEventIds: Array<string>, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteProductionCategoryMutationVariables = Types.Exact<{
  input: Types.DeleteProductionCategoryInput;
}>;


export type DeleteProductionCategoryMutation = { __typename?: 'Mutation', deleteProductionCategory: { __typename?: 'ProductionCategoryPayload', productionCategory?: { __typename?: 'ProductionCategoryStateData', productionCategoryId: string, tenantId: string, code: string, label?: string | null, eaches: number, laborCostPerUnit?: number | null, laborCostEffectiveDate?: Types.TDateISO | null, unitsPerPole?: number | null, status: Types.ProductionCategoryStatus, productionTaskEventIds: Array<string>, productionSpaceEventIds: Array<string>, productionSpaceCategoryId: string, productionMaterialEventIds: Array<string>, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetCategoryLaborCostMutationVariables = Types.Exact<{
  input: Types.SetCategoryLaborCostInput;
}>;


export type SetCategoryLaborCostMutation = { __typename?: 'Mutation', setCategoryLaborCost: { __typename?: 'ProductionCategoryPayload', productionCategory?: { __typename?: 'ProductionCategoryStateData', productionCategoryId: string, tenantId: string, code: string, label?: string | null, eaches: number, laborCostPerUnit?: number | null, laborCostEffectiveDate?: Types.TDateISO | null, unitsPerPole?: number | null, status: Types.ProductionCategoryStatus, productionTaskEventIds: Array<string>, productionSpaceEventIds: Array<string>, productionSpaceCategoryId: string, productionMaterialEventIds: Array<string>, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetCategoryUnitsPerPoleMutationVariables = Types.Exact<{
  input: Types.SetCategoryUnitsPerPoleInput;
}>;


export type SetCategoryUnitsPerPoleMutation = { __typename?: 'Mutation', setCategoryUnitsPerPole: { __typename?: 'ProductionCategoryPayload', productionCategory?: { __typename?: 'ProductionCategoryStateData', productionCategoryId: string, tenantId: string, code: string, label?: string | null, eaches: number, laborCostPerUnit?: number | null, laborCostEffectiveDate?: Types.TDateISO | null, unitsPerPole?: number | null, status: Types.ProductionCategoryStatus, productionTaskEventIds: Array<string>, productionSpaceEventIds: Array<string>, productionSpaceCategoryId: string, productionMaterialEventIds: Array<string>, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AddProductionSpaceEventToCategoryMutationVariables = Types.Exact<{
  input: Types.AddProductionSpaceEventToCategoryInput;
}>;


export type AddProductionSpaceEventToCategoryMutation = { __typename?: 'Mutation', addProductionSpaceEventToCategory: { __typename?: 'ProductionCategoryPayload', productionCategory?: { __typename?: 'ProductionCategoryStateData', productionCategoryId: string, tenantId: string, code: string, label?: string | null, eaches: number, laborCostPerUnit?: number | null, laborCostEffectiveDate?: Types.TDateISO | null, unitsPerPole?: number | null, status: Types.ProductionCategoryStatus, productionTaskEventIds: Array<string>, productionSpaceEventIds: Array<string>, productionSpaceCategoryId: string, productionMaterialEventIds: Array<string>, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RemoveProductionSpaceEventFromCategoryMutationVariables = Types.Exact<{
  input: Types.RemoveProductionSpaceEventFromCategoryInput;
}>;


export type RemoveProductionSpaceEventFromCategoryMutation = { __typename?: 'Mutation', removeProductionSpaceEventFromCategory: { __typename?: 'ProductionCategoryPayload', productionCategory?: { __typename?: 'ProductionCategoryStateData', productionCategoryId: string, tenantId: string, code: string, label?: string | null, eaches: number, laborCostPerUnit?: number | null, laborCostEffectiveDate?: Types.TDateISO | null, unitsPerPole?: number | null, status: Types.ProductionCategoryStatus, productionTaskEventIds: Array<string>, productionSpaceEventIds: Array<string>, productionSpaceCategoryId: string, productionMaterialEventIds: Array<string>, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AddProductionMaterialEventToCategoryMutationVariables = Types.Exact<{
  input: Types.AddProductionMaterialEventToCategoryInput;
}>;


export type AddProductionMaterialEventToCategoryMutation = { __typename?: 'Mutation', addProductionMaterialEventToCategory: { __typename?: 'ProductionCategoryPayload', productionCategory?: { __typename?: 'ProductionCategoryStateData', productionCategoryId: string, tenantId: string, code: string, label?: string | null, eaches: number, laborCostPerUnit?: number | null, laborCostEffectiveDate?: Types.TDateISO | null, unitsPerPole?: number | null, status: Types.ProductionCategoryStatus, productionTaskEventIds: Array<string>, productionSpaceEventIds: Array<string>, productionSpaceCategoryId: string, productionMaterialEventIds: Array<string>, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RemoveProductionMaterialEventFromCategoryMutationVariables = Types.Exact<{
  input: Types.RemoveProductionMaterialEventFromCategoryInput;
}>;


export type RemoveProductionMaterialEventFromCategoryMutation = { __typename?: 'Mutation', removeProductionMaterialEventFromCategory: { __typename?: 'ProductionCategoryPayload', productionCategory?: { __typename?: 'ProductionCategoryStateData', productionCategoryId: string, tenantId: string, code: string, label?: string | null, eaches: number, laborCostPerUnit?: number | null, laborCostEffectiveDate?: Types.TDateISO | null, unitsPerPole?: number | null, status: Types.ProductionCategoryStatus, productionTaskEventIds: Array<string>, productionSpaceEventIds: Array<string>, productionSpaceCategoryId: string, productionMaterialEventIds: Array<string>, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AddProductionTaskEventToCategoryMutationVariables = Types.Exact<{
  input: Types.AddProductionTaskEventToCategoryInput;
}>;


export type AddProductionTaskEventToCategoryMutation = { __typename?: 'Mutation', addProductionTaskEventToCategory: { __typename?: 'ProductionCategoryPayload', productionCategory?: { __typename?: 'ProductionCategoryStateData', productionCategoryId: string, tenantId: string, code: string, label?: string | null, eaches: number, laborCostPerUnit?: number | null, laborCostEffectiveDate?: Types.TDateISO | null, unitsPerPole?: number | null, status: Types.ProductionCategoryStatus, productionTaskEventIds: Array<string>, productionSpaceEventIds: Array<string>, productionSpaceCategoryId: string, productionMaterialEventIds: Array<string>, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RemoveProductionTaskEventFromCategoryMutationVariables = Types.Exact<{
  input: Types.RemoveProductionTaskEventFromCategoryInput;
}>;


export type RemoveProductionTaskEventFromCategoryMutation = { __typename?: 'Mutation', removeProductionTaskEventFromCategory: { __typename?: 'ProductionCategoryPayload', productionCategory?: { __typename?: 'ProductionCategoryStateData', productionCategoryId: string, tenantId: string, code: string, label?: string | null, eaches: number, laborCostPerUnit?: number | null, laborCostEffectiveDate?: Types.TDateISO | null, unitsPerPole?: number | null, status: Types.ProductionCategoryStatus, productionTaskEventIds: Array<string>, productionSpaceEventIds: Array<string>, productionSpaceCategoryId: string, productionMaterialEventIds: Array<string>, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const MergeProductionCategoryDocument = new TypedDocumentString(`
    mutation MergeProductionCategory($input: MergeProductionCategoryInput!) {
  mergeProductionCategory(input: $input) {
    productionCategory {
      ...ProductionCategoryData
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionCategoryData on ProductionCategoryStateData {
  productionCategoryId
  tenantId
  code
  label
  eaches
  laborCostPerUnit
  laborCostEffectiveDate
  unitsPerPole
  status
  productionTaskEventIds
  productionSpaceEventIds
  productionSpaceCategoryId
  productionMaterialEventIds
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const ActivateProductionCategoryDocument = new TypedDocumentString(`
    mutation ActivateProductionCategory($input: ActivateProductionCategoryInput!) {
  activateProductionCategory(input: $input) {
    productionCategory {
      ...ProductionCategoryData
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionCategoryData on ProductionCategoryStateData {
  productionCategoryId
  tenantId
  code
  label
  eaches
  laborCostPerUnit
  laborCostEffectiveDate
  unitsPerPole
  status
  productionTaskEventIds
  productionSpaceEventIds
  productionSpaceCategoryId
  productionMaterialEventIds
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const DeactivateProductionCategoryDocument = new TypedDocumentString(`
    mutation DeactivateProductionCategory($input: DeactivateProductionCategoryInput!) {
  deactivateProductionCategory(input: $input) {
    productionCategory {
      ...ProductionCategoryData
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionCategoryData on ProductionCategoryStateData {
  productionCategoryId
  tenantId
  code
  label
  eaches
  laborCostPerUnit
  laborCostEffectiveDate
  unitsPerPole
  status
  productionTaskEventIds
  productionSpaceEventIds
  productionSpaceCategoryId
  productionMaterialEventIds
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const UpdateProductionCategoryDetailsDocument = new TypedDocumentString(`
    mutation UpdateProductionCategoryDetails($input: UpdateProductionCategoryDetailsInput!) {
  updateProductionCategoryDetails(input: $input) {
    productionCategory {
      ...ProductionCategoryData
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionCategoryData on ProductionCategoryStateData {
  productionCategoryId
  tenantId
  code
  label
  eaches
  laborCostPerUnit
  laborCostEffectiveDate
  unitsPerPole
  status
  productionTaskEventIds
  productionSpaceEventIds
  productionSpaceCategoryId
  productionMaterialEventIds
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const DeleteProductionCategoryDocument = new TypedDocumentString(`
    mutation DeleteProductionCategory($input: DeleteProductionCategoryInput!) {
  deleteProductionCategory(input: $input) {
    productionCategory {
      ...ProductionCategoryData
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionCategoryData on ProductionCategoryStateData {
  productionCategoryId
  tenantId
  code
  label
  eaches
  laborCostPerUnit
  laborCostEffectiveDate
  unitsPerPole
  status
  productionTaskEventIds
  productionSpaceEventIds
  productionSpaceCategoryId
  productionMaterialEventIds
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const SetCategoryLaborCostDocument = new TypedDocumentString(`
    mutation SetCategoryLaborCost($input: SetCategoryLaborCostInput!) {
  setCategoryLaborCost(input: $input) {
    productionCategory {
      ...ProductionCategoryData
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionCategoryData on ProductionCategoryStateData {
  productionCategoryId
  tenantId
  code
  label
  eaches
  laborCostPerUnit
  laborCostEffectiveDate
  unitsPerPole
  status
  productionTaskEventIds
  productionSpaceEventIds
  productionSpaceCategoryId
  productionMaterialEventIds
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const SetCategoryUnitsPerPoleDocument = new TypedDocumentString(`
    mutation SetCategoryUnitsPerPole($input: SetCategoryUnitsPerPoleInput!) {
  setCategoryUnitsPerPole(input: $input) {
    productionCategory {
      ...ProductionCategoryData
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionCategoryData on ProductionCategoryStateData {
  productionCategoryId
  tenantId
  code
  label
  eaches
  laborCostPerUnit
  laborCostEffectiveDate
  unitsPerPole
  status
  productionTaskEventIds
  productionSpaceEventIds
  productionSpaceCategoryId
  productionMaterialEventIds
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const AddProductionSpaceEventToCategoryDocument = new TypedDocumentString(`
    mutation AddProductionSpaceEventToCategory($input: AddProductionSpaceEventToCategoryInput!) {
  addProductionSpaceEventToCategory(input: $input) {
    productionCategory {
      ...ProductionCategoryData
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionCategoryData on ProductionCategoryStateData {
  productionCategoryId
  tenantId
  code
  label
  eaches
  laborCostPerUnit
  laborCostEffectiveDate
  unitsPerPole
  status
  productionTaskEventIds
  productionSpaceEventIds
  productionSpaceCategoryId
  productionMaterialEventIds
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const RemoveProductionSpaceEventFromCategoryDocument = new TypedDocumentString(`
    mutation RemoveProductionSpaceEventFromCategory($input: RemoveProductionSpaceEventFromCategoryInput!) {
  removeProductionSpaceEventFromCategory(input: $input) {
    productionCategory {
      ...ProductionCategoryData
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionCategoryData on ProductionCategoryStateData {
  productionCategoryId
  tenantId
  code
  label
  eaches
  laborCostPerUnit
  laborCostEffectiveDate
  unitsPerPole
  status
  productionTaskEventIds
  productionSpaceEventIds
  productionSpaceCategoryId
  productionMaterialEventIds
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const AddProductionMaterialEventToCategoryDocument = new TypedDocumentString(`
    mutation AddProductionMaterialEventToCategory($input: AddProductionMaterialEventToCategoryInput!) {
  addProductionMaterialEventToCategory(input: $input) {
    productionCategory {
      ...ProductionCategoryData
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionCategoryData on ProductionCategoryStateData {
  productionCategoryId
  tenantId
  code
  label
  eaches
  laborCostPerUnit
  laborCostEffectiveDate
  unitsPerPole
  status
  productionTaskEventIds
  productionSpaceEventIds
  productionSpaceCategoryId
  productionMaterialEventIds
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const RemoveProductionMaterialEventFromCategoryDocument = new TypedDocumentString(`
    mutation RemoveProductionMaterialEventFromCategory($input: RemoveProductionMaterialEventFromCategoryInput!) {
  removeProductionMaterialEventFromCategory(input: $input) {
    productionCategory {
      ...ProductionCategoryData
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionCategoryData on ProductionCategoryStateData {
  productionCategoryId
  tenantId
  code
  label
  eaches
  laborCostPerUnit
  laborCostEffectiveDate
  unitsPerPole
  status
  productionTaskEventIds
  productionSpaceEventIds
  productionSpaceCategoryId
  productionMaterialEventIds
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const AddProductionTaskEventToCategoryDocument = new TypedDocumentString(`
    mutation AddProductionTaskEventToCategory($input: AddProductionTaskEventToCategoryInput!) {
  addProductionTaskEventToCategory(input: $input) {
    productionCategory {
      ...ProductionCategoryData
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionCategoryData on ProductionCategoryStateData {
  productionCategoryId
  tenantId
  code
  label
  eaches
  laborCostPerUnit
  laborCostEffectiveDate
  unitsPerPole
  status
  productionTaskEventIds
  productionSpaceEventIds
  productionSpaceCategoryId
  productionMaterialEventIds
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const RemoveProductionTaskEventFromCategoryDocument = new TypedDocumentString(`
    mutation RemoveProductionTaskEventFromCategory($input: RemoveProductionTaskEventFromCategoryInput!) {
  removeProductionTaskEventFromCategory(input: $input) {
    productionCategory {
      ...ProductionCategoryData
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionCategoryData on ProductionCategoryStateData {
  productionCategoryId
  tenantId
  code
  label
  eaches
  laborCostPerUnit
  laborCostEffectiveDate
  unitsPerPole
  status
  productionTaskEventIds
  productionSpaceEventIds
  productionSpaceCategoryId
  productionMaterialEventIds
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    MergeProductionCategory: build.mutation<MergeProductionCategoryMutation, MergeProductionCategoryMutationVariables>({
      query: (variables) => ({ document: MergeProductionCategoryDocument, variables })
    }),
    ActivateProductionCategory: build.mutation<ActivateProductionCategoryMutation, ActivateProductionCategoryMutationVariables>({
      query: (variables) => ({ document: ActivateProductionCategoryDocument, variables })
    }),
    DeactivateProductionCategory: build.mutation<DeactivateProductionCategoryMutation, DeactivateProductionCategoryMutationVariables>({
      query: (variables) => ({ document: DeactivateProductionCategoryDocument, variables })
    }),
    UpdateProductionCategoryDetails: build.mutation<UpdateProductionCategoryDetailsMutation, UpdateProductionCategoryDetailsMutationVariables>({
      query: (variables) => ({ document: UpdateProductionCategoryDetailsDocument, variables })
    }),
    DeleteProductionCategory: build.mutation<DeleteProductionCategoryMutation, DeleteProductionCategoryMutationVariables>({
      query: (variables) => ({ document: DeleteProductionCategoryDocument, variables })
    }),
    SetCategoryLaborCost: build.mutation<SetCategoryLaborCostMutation, SetCategoryLaborCostMutationVariables>({
      query: (variables) => ({ document: SetCategoryLaborCostDocument, variables })
    }),
    SetCategoryUnitsPerPole: build.mutation<SetCategoryUnitsPerPoleMutation, SetCategoryUnitsPerPoleMutationVariables>({
      query: (variables) => ({ document: SetCategoryUnitsPerPoleDocument, variables })
    }),
    AddProductionSpaceEventToCategory: build.mutation<AddProductionSpaceEventToCategoryMutation, AddProductionSpaceEventToCategoryMutationVariables>({
      query: (variables) => ({ document: AddProductionSpaceEventToCategoryDocument, variables })
    }),
    RemoveProductionSpaceEventFromCategory: build.mutation<RemoveProductionSpaceEventFromCategoryMutation, RemoveProductionSpaceEventFromCategoryMutationVariables>({
      query: (variables) => ({ document: RemoveProductionSpaceEventFromCategoryDocument, variables })
    }),
    AddProductionMaterialEventToCategory: build.mutation<AddProductionMaterialEventToCategoryMutation, AddProductionMaterialEventToCategoryMutationVariables>({
      query: (variables) => ({ document: AddProductionMaterialEventToCategoryDocument, variables })
    }),
    RemoveProductionMaterialEventFromCategory: build.mutation<RemoveProductionMaterialEventFromCategoryMutation, RemoveProductionMaterialEventFromCategoryMutationVariables>({
      query: (variables) => ({ document: RemoveProductionMaterialEventFromCategoryDocument, variables })
    }),
    AddProductionTaskEventToCategory: build.mutation<AddProductionTaskEventToCategoryMutation, AddProductionTaskEventToCategoryMutationVariables>({
      query: (variables) => ({ document: AddProductionTaskEventToCategoryDocument, variables })
    }),
    RemoveProductionTaskEventFromCategory: build.mutation<RemoveProductionTaskEventFromCategoryMutation, RemoveProductionTaskEventFromCategoryMutationVariables>({
      query: (variables) => ({ document: RemoveProductionTaskEventFromCategoryDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useMergeProductionCategoryMutation, useActivateProductionCategoryMutation, useDeactivateProductionCategoryMutation, useUpdateProductionCategoryDetailsMutation, useDeleteProductionCategoryMutation, useSetCategoryLaborCostMutation, useSetCategoryUnitsPerPoleMutation, useAddProductionSpaceEventToCategoryMutation, useRemoveProductionSpaceEventFromCategoryMutation, useAddProductionMaterialEventToCategoryMutation, useRemoveProductionMaterialEventFromCategoryMutation, useAddProductionTaskEventToCategoryMutation, useRemoveProductionTaskEventFromCategoryMutation } = injectedRtkApi;
